import { gql } from '@apollo/client'

export default gql(`
query($id: ID!) {
    getPlayerById(id: $id) {
        id
        opId
        firstName
        lastName
    }    
}`)
